import React, { useState } from "react";
import "./contact.css";

import Navbar from "../components/Navbar";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

import emailjs from "emailjs-com";
import Footer from "../components/Footer";

const initialState = {
  name: "",
  email: "",
  type: "",
  companyName: "",
  purpose: "",
  help: "",
};

const Contact = () => {
  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [submitError, setSubmitError] = useState("");

  /* ---------- HANDLE CHANGE ---------- */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  /* ---------- VALIDATION ---------- */
  const validate = () => {
    let newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Name is required.";
    if (!formData.email.trim()) newErrors.email = "Email is required.";
    if (!formData.type.trim()) newErrors.type = "Select a user type.";
    if (!formData.purpose.trim()) newErrors.purpose = "Purpose is required.";
    if (!formData.help.trim())
      newErrors.help = "Please describe how we can help.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* ---------- SUBMIT ---------- */
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitError("");
    setSubmitted(false);

    if (!validate()) return;

    const templateParams = {
      title:'Argus Contact',
      name: formData.name,
      email: formData.email,
      userType: formData.type,
      companyName: formData.companyName || "N/A",
      purpose: formData.purpose,
      help: formData.help,
    };

    emailjs
      .send(
        "service_y60jjpi",
        "template_hqyf5p6",
        templateParams,
        "McOBujFKjk1gyLjJ7"
      )
      .then(() => {
        setSubmitted(true);
        setFormData(initialState);
        setErrors({});
      })
      .catch(() => {
        setSubmitError(
          "Something went wrong while submitting the form. Please try again."
        );
      });
  };

  return (
    <>
      <Navbar />
      <div className="spacer"></div>

      <div className="contact-get-started-section">
        <h1>Get in Touch</h1>
        <h4>
          Where innovation powers automation for a smarter tomorrow. Ready to
          begin
        </h4>
      </div>

      <div className="container2211">
        <div className="row2211">
          <div className="col_contact col-12">
            <Form onSubmit={handleSubmit}>
              {/* NAME */}
              <Form.Group controlId="formName">
                <Form.Label>
                  Name<span className="text-danger"> *</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter your name"
                  isInvalid={!!errors.name}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.name}
                </Form.Control.Feedback>
              </Form.Group>

              {/* EMAIL */}
              <Form.Group controlId="formEmail" className="mt-4">
                <Form.Label>
                  Email<span className="text-danger"> *</span>
                </Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  isInvalid={!!errors.email}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </Form.Group>

              {/* USER TYPE */}
              <Form.Group controlId="formType" className="mt-4">
                <Form.Label>
                  User Type<span className="text-danger"> *</span>
                </Form.Label>
                <Form.Control
                  as="select"
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                  isInvalid={!!errors.type}
                >
                  <option value="">Select</option>
                  <option value="individual">Individual</option>
                  <option value="company">Company</option>
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {errors.type}
                </Form.Control.Feedback>
              </Form.Group>

              {/* PURPOSE */}
              <Form.Group controlId="formPurpose" className="mt-4">
                <Form.Label>
                  Purpose<span className="text-danger"> *</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="purpose"
                  value={formData.purpose}
                  onChange={handleChange}
                  placeholder="Enter the purpose"
                  isInvalid={!!errors.purpose}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.purpose}
                </Form.Control.Feedback>
              </Form.Group>

              {/* COMPANY */}
              <Form.Group controlId="formCompanyName" className="mt-4">
                <Form.Label>Company Name</Form.Label>
                <Form.Control
                  type="text"
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                  placeholder="Enter your company name"
                />
              </Form.Group>

              {/* HELP */}
              <Form.Group controlId="formHelp" className="mt-4">
                <Form.Label>
                  How Can We Help You?<span className="text-danger"> *</span>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  name="help"
                  value={formData.help}
                  onChange={handleChange}
                  rows={3}
                  placeholder="Describe how we can help you"
                  isInvalid={!!errors.help}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.help}
                </Form.Control.Feedback>
              </Form.Group>

              <Button type="submit" className="button_contact mt-5">
                Submit
              </Button>
            </Form>

            {submitted && (
              <p className="text-success mt-3">
                Your form has been submitted successfully!
              </p>
            )}

            {submitError && (
              <p className="text-danger mt-3">{submitError}</p>
            )}
          </div>
        </div>
      </div>

      <div className="background-image-container">
        <img
          src="Screenshot 2024-11-12 112713.png"
          alt="Responsive Background"
        />
      </div>

      <Footer />
    </>
  );
};

export default Contact;
